// extracted by mini-css-extract-plugin
export default {"profileBlock":"style_profileBlock__czsov","pencil":"style_pencil__E3u-J"};